import { FiArrowRight } from 'react-icons/fi';
import CurrentInformation from '../../molecules/CurrentInformation';
import useIsNativeView from '../../../hooks/useIsNativeView';
import { triggerNativeMessage } from '../../../helpers/utils';
import { Article, Province } from '../../../interface';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import eventClickDetailBranchSales from '../../../helpers/emarsys/branch-sales/eventClickDetailBranchSales';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { FEATURE, PAGE_NAME_BRANCH_SALES } from '../../../constants/emarsys/branch-sales';

interface ICurrentInformationSectionProps {
  data: Article[];
  title: string;
  description: string;
  baseUrl: string;
  hideSeeAllNewsButton?: boolean;
  breadcrumbItems?: IBreadcrumbs[];
  branchProvince?: Province;
  pageTitle?: string;
  city?: string;
  cityCode?: string;
  feature?: string;
}

const CurrentInformationSection = ({
  data = [],
  title = '',
  description = '',
  baseUrl = '',
  hideSeeAllNewsButton = false,
  breadcrumbItems = [],
  branchProvince,
  pageTitle = '',
  city = '',
  cityCode = '',
  feature = '',
}: ICurrentInformationSectionProps) => {
  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };
  const isNativeView = useIsNativeView();

  const handleGoToNewsTipsBranchList = (e, branch) => {
    if (isNativeView) {
      e.preventDefault();
    }

    if (feature === FEATURE.BRANCH_LISTING_PAGE) {
      eventClickSeeAllEmarsys();
    }

    const branchSlug = branch?.[0]?.branch?.branchLandingPage?.seoSlug || null;
    triggerNativeMessage('goToNewsTipsBranchList', { branchSlug });
  };

  const eventClickSeeAllEmarsys = () => {
    eventClickDetailBranchSales({
      dispatch,
      customerNo: userData?.customerNo,
      breadcrumbItems: breadcrumbItems,
      pageName: PAGE_NAME_BRANCH_SALES.LIST_DEALER_TOYOTA,
      pageTitle: pageTitle,
      sectionName: 'update bengkel',
      buttonName: 'lihat semua',
      newParams: {
        province: branchProvince?.name ?? '',
        province_code: branchProvince?.isocode ?? '',
        city: city,
        city_code: cityCode,
        ...(breadcrumbItems?.[2]?.name
          ? {
              menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase(),
            }
          : {}),
      },
    });
  };

  return (
    <section
      className="py-5 border-t-[5px] border-reliableBlack5 lg:py-10"
      data-testid="city-news-landing"
    >
      <div className="container px-0">
        <div className="flex justify-between lg:items-center gap-2 px-4 lg:px-0">
          <div className="flex flex-col gap-2">
            <h2 className="text-base font-bold uppercase mb-2 text-reliableBlack lg:text-2xl">
              {title}
            </h2>
          </div>
          {!hideSeeAllNewsButton && (
            <a
              id="branch-all-current-info-plp"
              href={PUBLIC_URL + `/dealer-toyota/${baseUrl}`}
              onClick={(e) => handleGoToNewsTipsBranchList(e, data)}
            >
              <div className="flex items-center justify-between gap-1 w-[111px] lg:w-[154px]">
                <span className="text-xs font-semibold lg:text-base lg:font-medium gap-[5px] lg:gap-3 leading-relaxed text-reliableBlack">
                  LIHAT SEMUA
                </span>
                <FiArrowRight size={20} color="#CE181E" />
              </div>
            </a>
          )}
        </div>
        <p className="text-xs text-reliableBlack mb-2 lg:text-base lg:mb-6 px-4 lg:px-0">
          {description}
        </p>

        <CurrentInformation
          items={data}
          pageTitle={pageTitle}
          breadcrumbItems={breadcrumbItems}
          branchProvince={branchProvince}
          city={city}
          cityCodeProps={cityCode}
          feature={feature}
        />
      </div>
    </section>
  );
};

export default CurrentInformationSection;
